import React from 'react';
import { integerToLetter } from '../../../../../../../../../../../../../../../utils/transformations';
import BulletIcon from '../../../../../../../../../../../../../../../assets/svg/circle-dot.svg';
import styles from './optionIcon.css';

/**
 *
 * @param bulletType
 * @param numberType
 * @param letterType
 * @param keyNumber
 * @param actionOnClick
 * @param elementHandle
 * @param elementStyle
 * @returns {JSX.Element}
 * @constructor
 */
const OptionIcon = React.memo(( { bulletType, numberType, letterType, keyNumber, actionOnClick, elementHandle, elementStyle } ) => {
    return (
        <div
            className={ styles.listType }
            onClick={ actionOnClick }>
            <div
                ref={ ( div ) => {
                    if ( elementHandle ) elementHandle[ keyNumber ] = div;
                } }
                style={ elementStyle }
                className={ styles.squarePoint }>
        <span className={ styles.listTypeText }>
            { bulletType && <BulletIcon className={ styles.bulletIcon }/> }
            { numberType && keyNumber + 1 }
            { letterType && integerToLetter( keyNumber ).toUpperCase() }
        </span>
            </div>
        </div>
    );
});

export default OptionIcon;